import { graphql } from '../graphql/types';
export const ServiceFragment = graphql(`
  fragment ServiceItem on NailAppointmentMenuProduct {
    id
    title
    code
    description
    images
    enabled
    inStock
    ingredients
    labels
    allergics
    priceMode
    section {
      ...MenuSectionItem
    }
    configurations {
      ...MenuProductConfigurationItem
    }

    appointmentMenuProductData {
      duration
    }

    menuId
    sectionId
  }
`);
